// extracted by mini-css-extract-plugin
export default {"root":"StrategyTradeDetails_root__Uil4s"};